// extracted by mini-css-extract-plugin
export default {"header":"header-EEjLA","closeIcon":"closeIcon-CT8ZN","subHeader":"subHeader-TTYs6","balls":"balls-WgjbA"};